export default "__VITE_ASSET__BVoliJeq__"